<main class="h-100 ts-bg-primary">
	<div class="h-100 d-flex flex-row">
		<div class="flex-grow-0 flex text-white h-100">
			<app-left-navigation></app-left-navigation>
			<app-sub-navigation class="h-100 bg-white bg-opa"></app-sub-navigation>
		</div>
		<div class="flex-grow p-0 flex flex-column">
			<header class="bg-white shadow-lg">
				<app-top-navigation></app-top-navigation>
			</header>
			<main class="flex-grow overflow-y-scroll bg-purple-50">
				<router-outlet class="h-full"></router-outlet>
			</main>
			<footer class="p-3 border-top bg-white text-end">
        <p>&copy; 2024 WhollyCity. All rights reserved.</p>
      </footer>
		</div>
	</div>
</main>
